import { render } from "./SoftVideo.vue?vue&type=template&id=ca7c041c"
import script from "./SoftVideo.vue?vue&type=script&lang=js"
export * from "./SoftVideo.vue?vue&type=script&lang=js"

import "./SoftVideo.vue?vue&type=style&index=0&id=ca7c041c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__